import { FC, useState } from 'react';

import { useTranslation } from 'react-i18next';
import SVGIcon from 'react-inlinesvg';

import IconAsk from '@assets/svg/icon-ask.svg';
import IconClose from '@assets/svg/icon-close.svg';
import { Button, QuestionsForm, SourceForm } from '@components';
import { composeClassName, FORUM_LINK } from '@utilities';

import styles from './index.module.scss';

export const Connect: FC = () => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [sourceFormVisible, setSourceFormVisible] = useState(false);
	const [questionsFormVisible, setQuestionsFormVisible] = useState(false);

	return (
		<div className={composeClassName(styles.container, open ? styles.opened : '')}>
			<button
				type="button"
				onClick={() => {
					setOpen(!open);
					setSourceFormVisible(false);
					setQuestionsFormVisible(false);
				}}
				className={styles.toggle}
				data-testid="connect-box-toggle"
			>
				<SVGIcon src={IconAsk} />
			</button>

			<button
				type="button"
				onClick={() => {
					setOpen(false);
					setSourceFormVisible(false);
					setQuestionsFormVisible(false);
				}}
				className={styles.close}
				data-testid="connect-box-close"
			>
				<SVGIcon src={IconClose} />
			</button>

			{!sourceFormVisible && !questionsFormVisible && (
				<div>
					<Button
						type="button"
						outline={true}
						onClick={() => setSourceFormVisible(true)}
						className={styles.button}
						data-testid="source-form-toggle"
					>
						{t('Add Your Source to dmarc.io')}
					</Button>

					<Button
						type="button"
						outline={true}
						onClick={() => setQuestionsFormVisible(true)}
						className={styles.button}
						data-testid="questions-form-toggle"
					>
						{t('Questions or Suggestions')}
					</Button>

					<Button
						rel="noopener noreferrer"
						href={FORUM_LINK}
						type="anchor"
						target="_blank"
						outline={true}
						className={styles.button}
						data-testid="forum-link"
					>
						{t('Community Discussions')}
					</Button>
				</div>
			)}

			{sourceFormVisible && <SourceForm onClose={() => setSourceFormVisible(false)} />}

			{questionsFormVisible && <QuestionsForm onClose={() => setQuestionsFormVisible(false)} />}
		</div>
	);
};

export default Connect;
